import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";

const styles = () => ({
  root: {
    height: "48px",
    width: "48px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    marginRight: "20px",
    position: "relative",
    flexShrink: 0,
    willChange: "transform",
    backfaceVisibility: "hidden",
    transform: "translateZ(0)",
  },
  img: {
    maxWidth: "48px",
    maxHeight: "48px",
    objectFit: "contain",
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    margin: "auto",
    willChange: "transform",
    backfaceVisibility: "hidden",
    transform: "translateZ(0)",
  },
});

class Logo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: false,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.props.item.logo_path !== nextProps.item.logo_path || 
           this.state.loaded !== nextState.loaded;
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.item.logo_path !== this.props.item.logo_path) {
      this.loadImage();
    }
  }

  loadImage = () => {
    const img = new Image();
    img.src = this.props.item.logo_path;
    img.onload = () => {
      this.setState({ loaded: true });
    };
  }

  render() {
    const { classes, item } = this.props;
    const { loaded } = this.state;

    return (
      <div className={classes.root}>
        {loaded && (
          <img
            src={item.logo_path}
            alt="logo"
            className={classes.img}
            loading="lazy"
          />
        )}
      </div>
    );
  }
}

Logo.propTypes = {
  classes: PropTypes.object.isRequired,
  item: PropTypes.object.isRequired,
};

export default withStyles(styles)(Logo);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/Spreadsheet/parts/Logo.jsx